import React from 'react';
import { BENEFITS } from '../data/content';
import { Reveal } from './Reveal';
export function Benefits() {
  return <section id="ventajas" className="bg-canvas py-16 sm:py-24" data-id="element-16" data-mp="9c792mowepjy">
      <div className="mx-auto max-w-[1240px] px-4 sm:px-6 lg:px-8" data-id="element-17" data-mp="4k5zx9n11ey5">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-18" data-mp="4icnfdpqg0i8">
          <p className="text-[11px] font-semibold uppercase tracking-overline text-brand-600" data-id="element-19" data-mp="3vppag9dar862">
            Ventajas
          </p>
          <h2 className="mt-4 text-[1.9rem] font-semibold leading-[1.1] tracking-[-0.025em] text-ink-900 sm:text-[2.6rem]" data-id="element-20" data-mp="3qsyudm1hsckn">
            Diseñado para tu forma de operar
          </h2>
        </Reveal>

        <ul className="mt-10 grid grid-cols-2 gap-3 sm:mt-12 sm:gap-5 lg:grid-cols-3" data-id="element-21" data-mp="3hr7ly9fkhrn3">
          {BENEFITS.map((benefit, i) => <Reveal key={benefit.number} delay={i % 3 * 0.05} className="h-full" data-id="element-22" data-mp="1fzcgwcntgldu" data-mpi={i}>
              <li className="flex h-full flex-col rounded-2xl border border-line bg-white p-4 shadow-card transition-[transform,box-shadow] duration-200 ease-expo hover:-translate-y-1 hover:shadow-lift sm:p-7" data-id="element-23" data-mp="1fx8bfqa9rebg">
                <span className="text-[12px] font-semibold tracking-[0.08em] text-brand-400 sm:text-[13px]" data-id="element-24" data-mp="6sjgc7kfjwq3">
                  {benefit.number}
                </span>
                <h3 className="mt-3 text-[15px] font-semibold leading-snug tracking-[-0.01em] text-ink-900 sm:mt-4 sm:text-[17px]" data-id="element-25" data-mp="3p08yg7g23gg4">
                  {benefit.title.charAt(0) + benefit.title.slice(1).toLowerCase()}
                </h3>
                <p className="mt-2 text-[13px] leading-relaxed text-ink-500 sm:mt-3 sm:text-[14.5px]" data-id="element-26" data-mp="qgir3iezv3vi">
                  {benefit.description}
                </p>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}